import Vue from 'vue'
import Router from 'vue-router'
import Cookies from 'js-cookie'
import store from '@/store'
import Login from '@/pages/Login' //登录
import Home from '@/pages/Home' //首页
import NotFound from '@/pages/Error/404' //错误页面
import {findNavTree} from '@/api/api'
import mian from '@/pages/sys/main' //首页
import admin_add from '@/pages/auxiliary/Admin_add'
import net from "@/constants/Net.Constants"

Vue.use(Router)
Vue.prototype.NET = net

 /**
import Main from '@/pages/Main' //主页
// import Device_add from '@/pages/Device_add' //设备添加
import Device_list from '@/pages/Device_list' //设备列表
import Account_list from '@/pages/Account_list' //用户列表
import Device_problem from '@/pages/Device_problem' //问题设备
import Card from '@/pages/card' //流量卡
import Warn_list from '@/pages/Warn_list' //报警管理
//import Agent_add from '@/pages/Agent_add' //经销商添加
import Agent_list from '@/pages/Agent_list' //经销商列表
import Today_data from '@/pages/Today_data' //当日报表
import Admin_list from '@/pages/Admin_list' //管理员列表
**/

const router = new Router({
    routes: [
      {
        path: '/',
        name: '首页',
        component: Home,
        children:[]
      },
      // {
      //   path: '/main',
      //   name: '广东湿',
      //   component: mian,
      //   meta:{requiresAuth:false}
      // }
      {
        path: '/login',
        name: '登录',
        component: Login
      },
      {
        path: '/404',
        name: 'notFound',
        component: NotFound
      }
    ]
})

router.beforeEach((to, from, next) => {
  //登录界面成功之后,会把用户信息保存在会话中, 页面关闭即失效

  let token  = Cookies.get('token')
  let userName = localStorage.getItem('user')

  if (to.path === '/login') {
      if (token) {
        //判断用户是否登录 会话信息存在 则跳转主页面
        next({path : '/'})
      }else {
        next()
      }
  }else {
    if (!token) {
      //判断用户是否登录 会话信息不存在 则跳转登录页面
      next({path : '/login'})
    }else {
      //加载路由
      addMenuAndRoutes(userName, to, from)
      next()
    }
  }
})

//加载动态路由菜单信息
function addMenuAndRoutes(userName, to, from) {

  // var registerRouteFresh = false
  //
  // store.state.menuRouteLoaded

  if (store.state.app.menuRouteLoaded) {
    // console.log("动态菜单和路由以存在")
    return
  }

    findNavTree(userName)
      .then(res => {
        console.log(res.data.result)
        //添加动态路由
        let dynamicRoutes = addDynamicRoutes(res.data.result)

        handleStaticComponent(router, dynamicRoutes)

        //路由存储到本地
        router.addRoutes(router.options.routes)
        //保存加载状态
        store.commit('menuRouteLoaded',true)
        // registerRouteFresh = true
        // console.log(registerRouteFresh)
        //保存菜单树
        store.commit('setNavTree',res.data.result)

      })
      .catch(function(res) {
      })
}

/**
 *  绑定静态组件
 * @param router
 * @param dynamicRoutes
 */
function handleStaticComponent(router, dynamicRoutes) {
  router.options.routes[0].children = router.options.routes[0].children .concat(dynamicRoutes)
}


/**
 *  动态添加路由
 * @param menuList 菜单列表
 * @param routes  递归创建动态路由菜单
 */
function addDynamicRoutes(menuList = [], routes = []) {
    let temp = []
    for (let i = 0; i < menuList.length; i++) {

      if (menuList[i].children && menuList[i].children.length >= 1) {
        temp = temp.concat(menuList[i].children)
      } else if (menuList[i].menuUrl &&  /\S/.test(menuList[i].menuUrl)) {

          menuList[i].menuUrl = menuList[i].menuUrl.replace(/^\//, '')

        //创建路由配置
        let route = {
            path: menuList[i].menuUrl,
            component: null,
            name: menuList[i].menuName,
            meta: {
                index: menuList[i].menuId,
                keepAlive:false
            }
        }

          // 根据菜单URL动态加载vue组件，这里要求vue组件须按照url路径存储
          // 如url="sys/user"，则组件路径应是"@/pages/sys/user.vue",否则组件加载不到
          try {

            let array = menuList[i].menuUrl.split('/')

            let url = ''
            for (let i = 0; i < array.length; i++) {
              url += array[i].substring(0,1) + array[i].substring(1) + '/'
            }
            url = url.substring(0,url.length - 1)

            route['component'] = resolve => require([`@/pages/${url}`], resolve)

          }catch (e) {}

        routes.push(route)

      }
    }

  if (temp.length >= 1) {
      addDynamicRoutes(temp, routes)
    } else {
      // console.log('动态路由加载...')
    }
  return routes
}

export default router



// WEBPACK FOOTER //
// ./src/router/index.js